<template>
  <div class="field">
    <input
      class="field__checkbox"
      v-bind:class="{ any }"
      type="checkbox"
      v-bind:name="nameCheckbox"
      v-bind:aria-label="ariaLabelCheckbox"
      v-bind:checked="checked"
      v-on:change="onChange" />
    <v-textarea
      class="field__textarea"
      data-lpignore="true"
      type="text"
      rows="1"
      hide-details
      no-resize
      auto-grow
      v-bind:class="{
        'field__textarea--is-disabled': disabled,
      }"
      v-bind:disabled="disabled"
      v-bind:value="title"
      v-bind:autocomplete="autocomplete"
      v-bind:aria-label="ariaLabelText"
      v-bind:maxlength="maxLength"
      v-bind:name="nameText"
      v-bind:required="required"
      v-bind:readonly="readonly"
      v-on:keydown.stop
      v-on:input="onInput"
      v-on:blur="onBlur" />
    <p
      class="text__violation"
      role="alert"
      v-for="error in inputErrors"
      v-bind:key="error"
    >
      {{ error }}
    </p>
  </div>
</template>
<script>

/**
 * @description Название события изменения.
 * @type {string}
 */
const NAME_EVENT_INPUT_CHANGE = 'update:checked';
/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';
/**
 * @description Название события фокуса.
 * @type {string}
 */
const NAME_EVENT_INPUT_BLUR = 'blur';

/**
 * @description Компонент флажка с редактируемым полем.
 * @type {Vue}
 */
export default {
  name: 'CheckboxTextarea',
  methods: {
    /**
     * @description Обработать изменение.
     * @param {Event} event
     * @returns {void}
     */
    onChange(event) {
      this.$emit(NAME_EVENT_INPUT_CHANGE, event.target.checked);
    },
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event Событие.
     * @returns {void}
     */
    onInput(event) {
      this.$emit(NAME_EVENT_INPUT, event);
    },
    /**
     * @description Обработать потерю фокуса.
     * @param {InputEvent} event Событие.
     * @param event
     */
    onBlur(event) {
      this.$emit(NAME_EVENT_INPUT_BLUR, event.target.value);
    },
  },
  props: {
    /**
     * @description Автозаполнение.
     * @type {boolean|string}
     */
    autocomplete: { default: () => false, type: [String, Boolean] },
    /**
     * @description Описание элемента текстового инпута.
     * @type {string}
     */
    ariaLabelText: { default: () => false, type: [String, Boolean] },
    /**
     * @description Максимальная длина.
     * @type {string|number}
     */
    maxLength: { default: () => false, type: [String, Number, Boolean] },
    /**
     * @description Уникальное имя элемента формы.
     * @type {String}
     */
    nameText: { default: () => false, type: [String, Boolean] },
    /**
     * @description Поле обязательно для заполнения.
     * @type {boolean|string}
     */
    required: { default: () => false, type: [String, Boolean] },
    /**
     * @description Поле обязательно для чтения.
     * @type {boolean|string}
     */
    readonly: { default: () => false, type: Boolean },
    /**
     * @description Заголовок.
     */
    title: { default: () => '', type: String },
    /**
     * @description Любой выбор (промежуточный).
     */
    any: { default: () => false, type: Boolean },
    /**
     * @description Деактивирован.
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Описание элемента чекбокса.
     * @type {string}
     */
    ariaLabelCheckbox: { default: () => false, type: [String, Boolean] },
    /**
     * @description Значение флажка.
     */
    checked: { required: true, type: Boolean },
    /**
     * @description Название поля чекбокса.
     */
    nameCheckbox: { default: () => '', type: String },
    /**
     * @description Ошибки
     */
    inputErrors: { default: () => [], type: Array },
  },
};
</script>
<style lang="scss" scoped>
.field {
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 50%;

  &__checkbox {
    content: '';
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    height: 1.5rem;
    margin: 0 10px 0 0;
    width: 1.5rem;
    background-color: var(--primary-background-color);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 70%;
    border: 1px solid var(--unfocus-color);
    border-radius: 4px;
    appearance: none;
    cursor: pointer;
  }

  &__textarea {
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    user-select: none;
    &--is-disabled {
      ::v-deep textarea {
        color: #000000;
      }
    }
  }
  &__checkbox:not(:disabled, :checked):hover{
    border-color: var(--action-color);
  }
  &__checkbox:not(:disabled):active {
    background-color: var(--unfocus-color);
    border-color: var(--unfocus-color);
  }
  &__checkbox:focus:not(:checked) {
    border-color: var(--unfocus-color);
  }
  &__checkbox:checked,
  &__checkbox.any:not(:checked) {
    background-color: var(--action-color);
    border-color: var(--action-color);
  }
  &__checkbox:checked {
    background-image: url("@/assets/img/checked/checked-white-top.svg");
  }
  &__checkbox.any:not(:checked) {
    background-image: url("@/assets/img/minus.svg");
  }
}

@media screen and (max-width: 786px) {
  .field {
    width: 100%;
  }
}
</style>
